// src/lib/cookies.ts
import Cookies from "js-cookie"

// Works for both v2 (@types) and v3 (built-in types)
type CookieOptions = NonNullable<Parameters<typeof Cookies.set>[2]>

export const COOKIE_KEYS = {
    SIDEBAR_STATE: "sidebar_state",
    THEME: "theme",
    // add more keys as you go (dealer_id, role, etc.)
} as const

export type CookieKey = typeof COOKIE_KEYS[keyof typeof COOKIE_KEYS]

export const cookie = {
    get(key: CookieKey): string | undefined {
        return Cookies.get(key)
    },

    set(key: CookieKey, value: string, options?: CookieOptions): void {
        const base: CookieOptions = { path: "/", sameSite: "strict" as const }
        Cookies.set(key, value, { ...base, ...options })
    },

    remove(key: CookieKey, options?: CookieOptions): void {
        Cookies.remove(key, { path: "/", ...(options ?? {}) })
    },

    // convenience helpers
    getBool(key: CookieKey): boolean {
        return Cookies.get(key) === "true"
    },
    setBool(key: CookieKey, value: boolean, options?: CookieOptions): void {
        this.set(key, String(value), options)
    },
}
